var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialTwitchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00063 0L1.4292 3.57143V16.4286H5.71491V20L9.28634 16.4286H12.1435L18.5721 10V0H5.00063ZM17.1435 9.28571L14.2863 12.1429H11.4292L8.9292 14.6429V12.1429H5.71491V1.42857H17.1435V9.28571Z",
    fill: "url(#paint0_linear_1128_154962)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0006 3.92859H13.572V8.2143H15.0006V3.92859Z",
    fill: "url(#paint1_linear_1128_154962)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.072 3.92859H9.64343V8.2143H11.072V3.92859Z",
    fill: "url(#paint2_linear_1128_154962)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1128_154962",
    x1: 1.4292,
    y1: 10,
    x2: 18.5721,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53584C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A68D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1128_154962",
    x1: 13.572,
    y1: 6.07145,
    x2: 15.0006,
    y2: 6.07145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53584C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A68D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1128_154962",
    x1: 9.64343,
    y1: 6.07145,
    x2: 11.072,
    y2: 6.07145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53584C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A68D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTwitchIcon);
export default __webpack_public_path__ + "static/media/SocialTwitchIcon.011a0468f94e7902815d27e4d5a42cf7.svg";
export { ForwardRef as ReactComponent };